<ion-header class="RepairCostDetail__Header">
  <ion-toolbar color="primary">
    <ion-title>Repairs Total: {{ total | currency }}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="RepairCostDetail__Container">
  <div class="container">
    <div class="row">
      <div class="col">
        <app-repair-cost-row
          class="RepairCostDetail__RepairRows"
          [form]="repairDetailForm"
          (newLineRequested)="addCost()"
        ></app-repair-cost-row>
        <!-- Add Another Repair -->
        <div class="row p-2 w-100">
          <ion-button fill="solid" color="secondary" (click)="addCost()">
            <ion-icon name="add" slot="start"></ion-icon>
            <span>Add&nbsp;</span>
            @if (repairDetailForm.get('details')?.value.length > 0) {
              <span [innerHTML]="'another '"> </span>
            }
            <span>&nbsp;cost</span>
          </ion-button>
        </div>
      </div>
    </div>
  </div>
</ion-content>

<ion-footer>
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-button
        class="RepairCostDetail__Button"
        fill="outline"
        [innerHTML]="'Cancel'"
        (click)="cancel()"
      ></ion-button>
      <ion-button
        class="RepairCostDetail__Button accent"
        [ngClass]="{
          'RepairCostDetail__Button--Disabled': repairDetailForm.invalid,
        }"
        [disabled]="!repairDetailForm.valid"
        fill="solid"
        color="primary"
        [innerHTML]="'Save'"
        (click)="save()"
      ></ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>
